import {AppThunkAction} from '../../../types/redux'
import {aFetchDirectors, selectDirectorsWhereLoaded} from '../../../data/directors'

export const selectDirectorItemsArePending = (state: Record<string, any>): boolean =>
  !selectDirectorsWhereLoaded(state)

export const aInitializeDirectorItems =
  (): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aFetchDirectors())
  }
